<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closePrinterNumberDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            {{ "by-p-num.title" | translate }}
        </h4>

        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3">
            <span class="text-center pb-4" [class.zx-ltr]="!isRTL" [class.zx-text-white]="isDarkMode">
                {{ "by-p-num.explain" | translate }}
            </span>


            <!-- ================= FIELD - PHONE -->
            <form class="w-100 d-flex flex-column gap-1" [formGroup]="form">
                <mat-form-field class="d-flex flex-grow-1 position-relative zx-z-index-1 zx-min-h-phone-input"
                    [class.zx-ltr]="!isRTL">
                    <mat-label>
                        {{ "by-p-num.printer-num" | translate }}
                    </mat-label>
                    <input [class.d-none]="isLoadingUpdates" matInput type="text" formControlName="printerNum"
                        [placeholder]="'by-p-num.printer-num' | translate" required appPhoneFormatDialog
                        [class.zx-ltr]="!isRTL" inputmode="numeric">
                    <div [class.d-none]="!isLoadingUpdates" class="w-100 d-flex justify-content-center"
                        [class.zx-ltr]="!isRTL" style="min-height: 24px;">
                        <mat-spinner class="zx-small-icon-size"></mat-spinner>
                    </div>
                    <mat-error *ngIf="form.get('printerNum').invalid" [class.zx-text-white]="isDarkMode"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        {{ "by-p-num.printer-num.error" | translate }}
                    </mat-error>
                    <!-- clear field -->
                    <div class="position-absolute justify-content-end px-2 zx-pb-12 rounded-pill top-clear-field w-100"
                        [class.d-flex]="form.get('printerNum').value && form.get('printerNum').value !== ''"
                        [class.d-none]="!(form.get('printerNum').value && form.get('printerNum').value !== '')"
                        [class.top-clear-field-not-rtl]="!isRTL">
                        <div matRipple (click)="clearPrinterNumField()"
                            class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                            <mat-icon class="m-0 p-1 zx-text-medium c-pointer">close</mat-icon>
                        </div>
                    </div>
                    <!-- // clear field -->
                </mat-form-field>

                <!-- options -->

                <div class="w-100 flex-column gap-1 px-2 pt-2 zx-text-tiny zx-text-sm-small rounded-bottom-3 zx-bg-gray overflow-auto"
                    style="transform: translateY(-26px); max-height: 280px;"
                    [class.d-flex]="form.get('printerNum').value && form.get('printerNum').value !== ''"
                    [class.d-none]="!(form.get('printerNum').value && form.get('printerNum').value !== '')">

                    <div class="w-100 flex-column gap-1 flex-grow-1">
                        <!-- PlotterBranches -->
                        <article matRipple (click)="onChooseBranch(false, branch)"
                            class="step-item-no-height step-item-hover d-flex flex-column flex-lg-row gap-2 rounded-3 px-2 px-md-3 pb-2 pb-md-3 pt-4 w-100 shadow-85 mb-2 position-relative"
                            [class.step-item-dark]="isDarkMode" *ngFor="let branch of filteredPlotterBranches">
                            <div class="w-100 position-absolute top-0 py-1">
                                <b class="zx-text-tiny zx-text-sm-small">
                                    <span>
                                        {{ "s-screen.title-sub.printer" | translate }}
                                    </span>
                                    <span>
                                        #{{ getPrinterNumber('plotter', branch) }}
                                    </span>
                                </b>
                            </div>
                            <div class="d-flex w-100 align-items-center gap-3 gap-lg-4 pt-1 pt-md-2"
                                [class.flex-row-reverse]="!isRTL">
                                <img class="zx-small-plus-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85"
                                    [src]="'assets/images/plotter-icon.svg'">
                                <img class="zx-small-plus-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85"
                                    [src]="'assets/images/branches/' + branch.name +'.png'">
                                <span>
                                    {{ "choose-branch.naming.plotter." + branch.name | translate }}
                                </span>
                            </div>
                        </article>
                        <!-- // PlotterBranches -->

                        <!-- ExpressBranches -->
                        <article matRipple (click)="onChooseBranch(true, branch)"
                            class="step-item-no-height step-item-hover d-flex flex-column flex-lg-row gap-2 rounded-3 px-2 px-md-3 pb-2 pb-md-3 pt-4 w-100 shadow-85 mb-2 position-relative"
                            [class.step-item-dark]="isDarkMode" *ngFor="let branch of filteredExpressBranches">
                            <div class="w-100 position-absolute top-0 py-1">
                                <b class="zx-text-tiny zx-text-sm-small">
                                    <span>
                                        {{ "s-screen.title-sub.printer" | translate }}
                                    </span>
                                    <span>
                                        #{{ getPrinterNumber('express', branch) }}
                                    </span>
                                </b>
                            </div>
                            <div class="d-flex w-100 align-items-center gap-3 gap-lg-4 pt-1 pt-md-2"
                                [class.flex-row-reverse]="!isRTL">
                                <img class="zx-small-plus-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85"
                                    [src]="'assets/images/' + getIsPics(branch) + '-icon.svg'">
                                <img class="zx-small-plus-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85"
                                    [src]="'assets/images/branches/' + branch.name +'.png'">
                                <span>
                                    {{ "choose-branch.naming.express." + branch.name | translate }}
                                </span>
                            </div>
                        </article>
                        <!-- // ExpressBranches -->
                    </div>

                </div>
                <!-- // options -->

            </form>
        </div>

    </div>
</div>